<template>
    <div class="messages position-relative">
        <div data-name="messages-header">
            <router-link id="partner-campaign-link-chatroom" :to="{ path: `/${isEcommercePlatform ? 'shops' : 'campaigns'}/${room.contact_camp_id}`}">
                <div data-name="contact-details">
                    <img v-lazy="room.contact_pic" alt="">
                    <p>{{room.contact_name}}</p>
                </div>
            </router-link>
            <Request v-if="room.requests" :requests="room.requests" />
        </div>
        <div 
            ref="messagesBox" 
            data-name="messages-body"
            id="conversation-scroll">
                <MessageItem
                    v-for="message in messages" 
                    :key="`message-${message.id}`"
                    :message="message"
                    />
        </div>
        <div data-name="messages-footer">
            <NewMessage :room="room" />
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Request from './Request'
import NewMessage from './NewMessage'
import { chatUseCase } from '../../../core/usecases'
import {Loader} from '../../../components/Icons'
import MessageItem from './MessageItem'
import Icon from '../../../components/Theme/Icon'

export default {
    name: 'chat-messages',
    components: {
        NewMessage,
        Loader,
        Request,
        MessageItem,
        Icon
    },
    props: [
        'room',
        'emptyChat'
    ],
    data: function () {
        return {
            messages: [],
            lastMessage: '',
            loading: false,
            detachMessagesListener: () => {}
        }
    },
    computed: {
        ...mapState([
            'user',
        ]),
        ...mapGetters([
            'isEcommercePlatform'
        ])
    },
    mounted() {
        if(!this.emptyChat) {
            this.loading = true;
        }
        this.detachMessagesListener = chatUseCase.getMessages(this.room.id, this.onMessage)
        chatUseCase.markRoomAsSeen(this.room)
    },
    destroyed: function () {
        this.detachMessagesListener()
    },
    methods: {
        onMessage: function (message) {
            this.messages = [
                ...this.messages,
                message,
            ]

            this.loading = false;

            this.$nextTick(() => {
                if (!this.$refs.messagesBox) {
                    return
                }

                this.$refs.messagesBox.scrollTop = this.$refs.messagesBox.scrollHeight
            })
        },
    },
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/mixins';
div.messages {
    width: 100%;
    display: flex;
    flex-direction: column;

    div[data-name="messages-header"] {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
        padding-left: 32px;
        height: 88px;
        max-height: 88px;
        min-height: 88px;
        border-bottom: 1px solid #D6DDE3;
        div[data-name="contact-details"] {
            display: flex;
            align-items: center;

            img {
                width: 46px;
                max-width: 46px;
                height: 46px;
                border-radius: 50%;
                object-fit: cover;
            }
            p {
                margin-left: 16px;
                margin-bottom: 0;
                font-size: 16px;
                color: #333333;
                font-weight: bold;
                word-break: break-all;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
    }
    div[data-name="messages-body"] {
        padding-left: 48px;
        padding-right: 48px;
        flex-grow: 1;
        overflow-y: auto;

        .my-message {
            span {
                color: red !important;
                a {
                    color: #ffffff !important;
                }
            }
        }
    }
    div[data-name="messages-footer"] {
        padding-left: 48px;
        padding-right: 48px;
        padding-bottom: 32px;
        padding-top: 24px;
    }
}
</style>